/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as auth403RouteImport } from './routes/(auth)/403'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedBivySticksRouteImport } from './routes/_authenticated/bivy-sticks'
import { Route as AuthenticatedOrganizationsIndexRouteImport } from './routes/_authenticated/organizations.index'
import { Route as AuthenticatedOrganizationsIdRouteImport } from './routes/_authenticated/organizations.$id'
import { Route as AuthenticatedSettingsIntegrationsRouteImport } from './routes/_authenticated/settings/integrations'
import { Route as AuthenticatedSettingsTasksRouteImport } from './routes/_authenticated/settings/tasks'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users.index'
import { Route as AuthenticatedUsersIdRouteImport } from './routes/_authenticated/users.$id'
import { Route as AuthenticatedSettingsIncidentTypesIndexRouteImport } from './routes/_authenticated/settings/incident-types.index'
import { Route as AuthenticatedSettingsIncidentTypesIdRouteImport } from './routes/_authenticated/settings/incident-types.$id'
import { Route as AuthenticatedSettingsPlansIndexRouteImport } from './routes/_authenticated/settings/plans.index'
import { Route as AuthenticatedSettingsPlansIdRouteImport } from './routes/_authenticated/settings/plans.$id'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const auth403Route = auth403RouteImport.update({
  id: '/(auth)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedBivySticksRoute = AuthenticatedBivySticksRouteImport.update({
  id: '/bivy-sticks',
  path: '/bivy-sticks',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedOrganizationsIndexRoute =
  AuthenticatedOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOrganizationsIdRoute =
  AuthenticatedOrganizationsIdRouteImport.update({
    id: '/organizations/$id',
    path: '/organizations/$id',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsIntegrationsRoute =
  AuthenticatedSettingsIntegrationsRouteImport.update({
    id: '/settings/integrations',
    path: '/settings/integrations',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsTasksRoute =
  AuthenticatedSettingsTasksRouteImport.update({
    id: '/settings/tasks',
    path: '/settings/tasks',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedUsersIdRoute = AuthenticatedUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSettingsIncidentTypesIndexRoute =
  AuthenticatedSettingsIncidentTypesIndexRouteImport.update({
    id: '/settings/incident-types/',
    path: '/settings/incident-types/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsIncidentTypesIdRoute =
  AuthenticatedSettingsIncidentTypesIdRouteImport.update({
    id: '/settings/incident-types/$id',
    path: '/settings/incident-types/$id',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsPlansIndexRoute =
  AuthenticatedSettingsPlansIndexRouteImport.update({
    id: '/settings/plans/',
    path: '/settings/plans/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsPlansIdRoute =
  AuthenticatedSettingsPlansIdRouteImport.update({
    id: '/settings/plans/$id',
    path: '/settings/plans/$id',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/403': typeof auth403Route
  '/sign-in': typeof authSignInRoute
  '/bivy-sticks': typeof AuthenticatedBivySticksRoute
  '/organizations/$id': typeof AuthenticatedOrganizationsIdRoute
  '/settings/integrations': typeof AuthenticatedSettingsIntegrationsRoute
  '/settings/tasks': typeof AuthenticatedSettingsTasksRoute
  '/users/$id': typeof AuthenticatedUsersIdRoute
  '/organizations/': typeof AuthenticatedOrganizationsIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/settings/incident-types/$id': typeof AuthenticatedSettingsIncidentTypesIdRoute
  '/settings/plans/$id': typeof AuthenticatedSettingsPlansIdRoute
  '/settings/incident-types/': typeof AuthenticatedSettingsIncidentTypesIndexRoute
  '/settings/plans/': typeof AuthenticatedSettingsPlansIndexRoute
}
export interface FileRoutesByTo {
  '/403': typeof auth403Route
  '/sign-in': typeof authSignInRoute
  '/bivy-sticks': typeof AuthenticatedBivySticksRoute
  '/': typeof AuthenticatedIndexRoute
  '/organizations/$id': typeof AuthenticatedOrganizationsIdRoute
  '/settings/integrations': typeof AuthenticatedSettingsIntegrationsRoute
  '/settings/tasks': typeof AuthenticatedSettingsTasksRoute
  '/users/$id': typeof AuthenticatedUsersIdRoute
  '/organizations': typeof AuthenticatedOrganizationsIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/settings/incident-types/$id': typeof AuthenticatedSettingsIncidentTypesIdRoute
  '/settings/plans/$id': typeof AuthenticatedSettingsPlansIdRoute
  '/settings/incident-types': typeof AuthenticatedSettingsIncidentTypesIndexRoute
  '/settings/plans': typeof AuthenticatedSettingsPlansIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/(auth)/403': typeof auth403Route
  '/(auth)/sign-in': typeof authSignInRoute
  '/_authenticated/bivy-sticks': typeof AuthenticatedBivySticksRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/organizations/$id': typeof AuthenticatedOrganizationsIdRoute
  '/_authenticated/settings/integrations': typeof AuthenticatedSettingsIntegrationsRoute
  '/_authenticated/settings/tasks': typeof AuthenticatedSettingsTasksRoute
  '/_authenticated/users/$id': typeof AuthenticatedUsersIdRoute
  '/_authenticated/organizations/': typeof AuthenticatedOrganizationsIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/settings/incident-types/$id': typeof AuthenticatedSettingsIncidentTypesIdRoute
  '/_authenticated/settings/plans/$id': typeof AuthenticatedSettingsPlansIdRoute
  '/_authenticated/settings/incident-types/': typeof AuthenticatedSettingsIncidentTypesIndexRoute
  '/_authenticated/settings/plans/': typeof AuthenticatedSettingsPlansIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/403'
    | '/sign-in'
    | '/bivy-sticks'
    | '/organizations/$id'
    | '/settings/integrations'
    | '/settings/tasks'
    | '/users/$id'
    | '/organizations/'
    | '/users/'
    | '/settings/incident-types/$id'
    | '/settings/plans/$id'
    | '/settings/incident-types/'
    | '/settings/plans/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/403'
    | '/sign-in'
    | '/bivy-sticks'
    | '/'
    | '/organizations/$id'
    | '/settings/integrations'
    | '/settings/tasks'
    | '/users/$id'
    | '/organizations'
    | '/users'
    | '/settings/incident-types/$id'
    | '/settings/plans/$id'
    | '/settings/incident-types'
    | '/settings/plans'
  id:
    | '__root__'
    | '/_authenticated'
    | '/(auth)/403'
    | '/(auth)/sign-in'
    | '/_authenticated/bivy-sticks'
    | '/_authenticated/'
    | '/_authenticated/organizations/$id'
    | '/_authenticated/settings/integrations'
    | '/_authenticated/settings/tasks'
    | '/_authenticated/users/$id'
    | '/_authenticated/organizations/'
    | '/_authenticated/users/'
    | '/_authenticated/settings/incident-types/$id'
    | '/_authenticated/settings/plans/$id'
    | '/_authenticated/settings/incident-types/'
    | '/_authenticated/settings/plans/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  auth403Route: typeof auth403Route
  authSignInRoute: typeof authSignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/403': {
      id: '/(auth)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof auth403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/bivy-sticks': {
      id: '/_authenticated/bivy-sticks'
      path: '/bivy-sticks'
      fullPath: '/bivy-sticks'
      preLoaderRoute: typeof AuthenticatedBivySticksRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/organizations/': {
      id: '/_authenticated/organizations/'
      path: '/organizations'
      fullPath: '/organizations/'
      preLoaderRoute: typeof AuthenticatedOrganizationsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/organizations/$id': {
      id: '/_authenticated/organizations/$id'
      path: '/organizations/$id'
      fullPath: '/organizations/$id'
      preLoaderRoute: typeof AuthenticatedOrganizationsIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/integrations': {
      id: '/_authenticated/settings/integrations'
      path: '/settings/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AuthenticatedSettingsIntegrationsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/tasks': {
      id: '/_authenticated/settings/tasks'
      path: '/settings/tasks'
      fullPath: '/settings/tasks'
      preLoaderRoute: typeof AuthenticatedSettingsTasksRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/$id': {
      id: '/_authenticated/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AuthenticatedUsersIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/incident-types/': {
      id: '/_authenticated/settings/incident-types/'
      path: '/settings/incident-types'
      fullPath: '/settings/incident-types/'
      preLoaderRoute: typeof AuthenticatedSettingsIncidentTypesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/incident-types/$id': {
      id: '/_authenticated/settings/incident-types/$id'
      path: '/settings/incident-types/$id'
      fullPath: '/settings/incident-types/$id'
      preLoaderRoute: typeof AuthenticatedSettingsIncidentTypesIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/plans/': {
      id: '/_authenticated/settings/plans/'
      path: '/settings/plans'
      fullPath: '/settings/plans/'
      preLoaderRoute: typeof AuthenticatedSettingsPlansIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/plans/$id': {
      id: '/_authenticated/settings/plans/$id'
      path: '/settings/plans/$id'
      fullPath: '/settings/plans/$id'
      preLoaderRoute: typeof AuthenticatedSettingsPlansIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedBivySticksRoute: typeof AuthenticatedBivySticksRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedOrganizationsIdRoute: typeof AuthenticatedOrganizationsIdRoute
  AuthenticatedSettingsIntegrationsRoute: typeof AuthenticatedSettingsIntegrationsRoute
  AuthenticatedSettingsTasksRoute: typeof AuthenticatedSettingsTasksRoute
  AuthenticatedUsersIdRoute: typeof AuthenticatedUsersIdRoute
  AuthenticatedOrganizationsIndexRoute: typeof AuthenticatedOrganizationsIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedSettingsIncidentTypesIdRoute: typeof AuthenticatedSettingsIncidentTypesIdRoute
  AuthenticatedSettingsPlansIdRoute: typeof AuthenticatedSettingsPlansIdRoute
  AuthenticatedSettingsIncidentTypesIndexRoute: typeof AuthenticatedSettingsIncidentTypesIndexRoute
  AuthenticatedSettingsPlansIndexRoute: typeof AuthenticatedSettingsPlansIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedBivySticksRoute: AuthenticatedBivySticksRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedOrganizationsIdRoute: AuthenticatedOrganizationsIdRoute,
  AuthenticatedSettingsIntegrationsRoute:
    AuthenticatedSettingsIntegrationsRoute,
  AuthenticatedSettingsTasksRoute: AuthenticatedSettingsTasksRoute,
  AuthenticatedUsersIdRoute: AuthenticatedUsersIdRoute,
  AuthenticatedOrganizationsIndexRoute: AuthenticatedOrganizationsIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedSettingsIncidentTypesIdRoute:
    AuthenticatedSettingsIncidentTypesIdRoute,
  AuthenticatedSettingsPlansIdRoute: AuthenticatedSettingsPlansIdRoute,
  AuthenticatedSettingsIncidentTypesIndexRoute:
    AuthenticatedSettingsIncidentTypesIndexRoute,
  AuthenticatedSettingsPlansIndexRoute: AuthenticatedSettingsPlansIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  auth403Route: auth403Route,
  authSignInRoute: authSignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
